export default state => state.amazonpay.amazonpayScriptLoadStatus;
